/*
 *   File : listing.js
 *   Author URI : https://evoqins.com
 *   Description : Listing page for 
 *   Integrations : null
 *   Version : v1.1
 */
// import packages
import { useEffect, useState, useRef } from "react";
import { Modal } from "bootstrap";
// import components
import { NavigationHeader } from "../../Components/Header";
import { CustomLoader, EmptyScreen } from "../../Components/Other";
import { CustomTab } from "../../Components/Tab";
import { DataTableContainer, CustomSearchSelectBox, SearchInput } from "../../Components/FormElements";
import { Icon } from "../../Components/Icon";
import { CreateRMModal, RemoveRMModal, TransferAPModal } from "../../Components/Modal";
import { GradientButton } from "../../Components/Cta";

import Colors from '../../Styles/color.module.scss';
// import services
import APIService from "../../Services/api-service";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const PAGE_NAVIGATION = [
    'Home',
    'Manage Hierarchy'
];

const ALL_TABS = [
    "Region Management",
    "Zone Management",
    "Branch Management",
    "RM Management",
    "AP Management",
    "Manage Hierarchy"
]


export default function HierachyLisitng(props) {

    const navigate = useNavigate();
    const { state } = useLocation();
    const [tabIndex, setTabIndex] = useState(1);
    const [apiLoader, setApiLoader] = useState(true);
    const [tableData, setTableData] = useState([]);
    const [showDeletedRed, setShowDeletedRed] = useState(-1);
    const [openCreateModal, setOpenCreaetModal] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const [modalTitle, setModalTitle] = useState("");
    const [zoneList, setZoneList] = useState([]);
    const [associateList, setAssociateList] = useState([]);
    const [rmList, setRmList] = useState([]);

    console.log('zoneList', zoneList);
    console.log('selectedData', selectedData);


    const [regionList, setRegionList] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [remapAvailable, setRemapAvailable] = useState(false);
    const [selectedZone, setSelectedZone] = useState({});
    const [selectedRegion, setSelectedRegion] = useState({});
    const [selectedBranch, setSelectedBranch] = useState({});
    const [selectedRM, setSelectedRM] = useState({});
    const [openTransferModal, setOpenTransferModal] = useState(false);
    const [selectedTransferRow, setSelectedTransferRow] = useState(null);

    // manage hierarchy
    const [adminType, setAdminType] = useState({});
    const [fromAdmin, setFromAdmin] = useState({});
    const [toAdmin, setToAdmin] = useState({});
    const [adminOptions, setAdminOptions] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    console.log('customerList', customerList);

    const [selectedCustomers, setSelectedCustomers] = useState([]);
    const [deleteOldAdmin, setDeleteOldAdmin] = useState(false);
    const [selectAllCustomers, setSelectAllCustomers] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    // const [pageNumber, setCurrentPage] = useState(1);
    const [totalLength, setTotalLength] = useState(0);
    const [totalPages, setTotalPages] = useState(null);
    const [paginationData, setPaginationData] = useState(null);
    const ADMIN_PROFILE_DATA = useSelector(state => state.MT_ADMIN_STORE.ADMIN_PROFILE);
    const isOpsAdmin = [1, 2].includes(ADMIN_PROFILE_DATA?.admin_type_id);
    const TAB_DATA = isOpsAdmin ? ALL_TABS : ALL_TABS.slice(0, 5);

    const TABLE_STYLE = {
        table: {
            style: {
                padding: "12px 16px 16px 16px",
                background: Colors.white,
            },
        },
        tableBody: {
            style: {
                margin: '0px',
                marginTop: "0px !important"
            }
        },
        headRow: {
            style: {
                background: 'transparent',
                borderRadius: "16px 16px 0px 0px",
                border: "0",
                borderBottom: `1px solid ${Colors.bright_gray} !important`,
                fontSize: "14px",
                fontFamily: "Poppins-Medium",
                lineHeight: "24px",
                color: Colors.outer_space
            }
        },
        rows: {
            style: {
                margin: "0",
                background: "transparent",
                border: `1px solid ${Colors.bright_gray} !important`,
                borderRadius: "16px",
                marginTop: "14px",
                fontSize: "16px",
                fontFamily: "Poppins-Regular",
                lineHeight: "24px",
            },
        },
        cells: {
            style: {
                '&:not(:last-child)': {
                    paddingLeft: '0px',
                    paddingRight: '0px',
                    display: 'flex',
                },
                '&:first-child': {
                    padding: "24px 0px 24px 24px",
                }
            },
        },
        headCells: {
            style: {
                '&:not(:last-child)': {
                    paddingLeft: '0px',
                    paddingRight: '0px',
                    display: 'flex',
                },
                '&:first-child': {
                    padding: "24px 0px 24px 24px",
                }
            },
        },
        pagination: {
            style: {
                borderTop: `none `,
                color: Colors.outer_space,
                fontSize: '16px',
                fontFamily: "Poppins-Regular",
            },
        }
    }

    const ZONE_COLUMNS = [

        {
            name: <div className={`position-relative w-fit-content `}>


                <p className="mb-0">Name</p>
            </div>,
            selector: row => row['name'],
            sortable: true,
            left: true,
            width: '300px',
            cell: row =>
                <div className="d-flex align-items-center gap-12px e-fund-name ps-2" >

                    <p className="color-primary-color e-poppins-regular e-font-16 line-height-24px mb-0 bg-white mt-0">{row['name']}</p>
                </div>
        },
        {
            name: 'Code',
            selector: row => row['code'],
            sortable: false,
            left: true,
            width: '300px',
            cell: row => <span className="color-outer-space"> {row['code']}</span>,
        },
        {
            name: '',
            sortable: false,
            center: true,
            width: "300px",
            cell: (row, key) =>
                <div className="d-flex">
                    <p className='color-primary-color line-height-16px e-poppins-regular e-font-16 e-tool-tip-container position-relative h-fit-content  my-0 cursor-pointer'
                        data-tooltip-content="Edit selected"
                        placement="bottom"
                        onClick={() => _handleEdit(row)}>
                        Edit
                        <Icon icon="Pen-square"
                            size={24}
                            className="ms-1" />
                    </p>
                    <p className={`${showDeletedRed === key ? 'color-red' : 'color-primary-color'} line-height-16px e-poppins-regular e-font-16  my-0 ps-3 e-tool-tip-container position-relative h-fit-content`}
                        data-tooltip-content="Delete selected"
                        placement="bottom"
                        onMouseEnter={() => {
                            setShowDeletedRed(key);
                        }}
                        onMouseLeave={() => {
                            setShowDeletedRed(-1);
                        }}
                        onClick={() => _handleDeleteClick(row)}>
                        Remove


                        <Icon icon={showDeletedRed === key ? "delete-red" : "delete"}
                            size={24}
                        />

                    </p>
                </div>
        },

    ];

    const REGION_COLUMN = [

        {
            name: <div className={`position-relative w-fit-content `}>


                <p className="mb-0">Name</p>
            </div>,
            selector: row => row['name'],
            sortable: true,
            left: true,
            width: '300px',
            cell: row =>
                <div className="d-flex align-items-center gap-12px e-fund-name ps-2" >

                    <p className="color-primary-color e-poppins-regular e-font-16 line-height-24px mb-0 bg-white mt-0">{row['name']}</p>
                </div>
        },
        {
            name: 'Code',
            selector: row => row['code'],
            sortable: false,
            left: true,
            width: '300px',
            cell: row => <span className="color-outer-space"> {row['code']}</span>,
        },
        {
            name: '',
            sortable: false,
            center: true,
            width: "300px",
            cell: (row, key) =>
                <div className="d-flex">
                    <p className='color-primary-color line-height-16px e-poppins-regular e-font-16 e-tool-tip-container position-relative h-fit-content  my-0 cursor-pointer'
                        data-tooltip-content="Edit selected"
                        placement="bottom"
                        onClick={() => _handleEdit(row)}>
                        Edit
                        <Icon icon="Pen-square"
                            size={24}
                            className="ms-1" />
                    </p>
                    <p className={`${showDeletedRed === key ? 'color-red' : 'color-primary-color'} line-height-16px e-poppins-regular e-font-16  my-0 ps-3 e-tool-tip-container position-relative h-fit-content`}
                        data-tooltip-content="Delete selected"
                        placement="bottom"
                        onMouseEnter={() => {
                            setShowDeletedRed(key);
                        }}
                        onMouseLeave={() => {
                            setShowDeletedRed(-1);
                        }}
                        onClick={() => _handleDeleteClick(row)}>
                        Remove


                        <Icon icon={showDeletedRed === key ? "delete-red" : "delete"}
                            size={24}
                        />

                    </p>
                </div>
        },

    ];

    const BRNACH_COLUMN = [

        {
            name: <div className={`position-relative w-fit-content `}>


                <p className="mb-0">Name</p>
            </div>,
            selector: row => row['name'],
            sortable: true,
            left: true,
            width: '300px',
            cell: row =>
                <div className="d-flex align-items-center gap-12px e-fund-name ps-2" >

                    <p className="color-primary-color e-poppins-regular e-font-16 line-height-24px mb-0 bg-white mt-0">{row['name']}</p>
                </div>
        },
        {
            name: 'Code',
            selector: row => row['code'],
            sortable: false,
            left: true,
            width: '300px',
            cell: row => <span className="color-outer-space"> {row['code']}</span>,
        },
        {
            name: '',
            sortable: false,
            center: true,
            width: "300px",
            cell: (row, key) =>
                <div className="d-flex">
                    <p className='color-primary-color line-height-16px e-poppins-regular e-font-16 e-tool-tip-container position-relative h-fit-content  my-0 cursor-pointer'
                        data-tooltip-content="Edit selected"
                        placement="bottom"
                        onClick={() => _handleEdit(row)}>
                        Edit
                        <Icon icon="Pen-square"
                            size={24}
                            className="ms-1" />
                    </p>
                    <p className={`${showDeletedRed === key ? 'color-red' : 'color-primary-color'} line-height-16px e-poppins-regular e-font-16  my-0 ps-3 e-tool-tip-container position-relative h-fit-content`}
                        data-tooltip-content="Delete selected"
                        placement="bottom"
                        onMouseEnter={() => {
                            setShowDeletedRed(key);
                        }}
                        onMouseLeave={() => {
                            setShowDeletedRed(-1);
                        }}
                        onClick={() => _handleDeleteClick(row)}>
                        Remove


                        <Icon icon={showDeletedRed === key ? "delete-red" : "delete"}
                            size={24}
                        />

                    </p>
                </div>
        },

    ];


    const CUSTOMER_COLUMNS = [

        {
            name: (
                <input
                    type="checkbox"
                    checked={selectAllCustomers}
                    onChange={_toggleSelectAll}
                />
            ),
            width: '80px',
            cell: (row) => (
                <input
                    type="checkbox"
                    checked={selectedCustomers.includes(row.customer_id)}
                    onChange={() => _toggleCustomer(row.customer_id)}
                />
            )
        },

        {
            name: 'Client Code',
            width: '190px',
            selector: row => row.client_code,
            cell: row => <span>{row.client_code}</span>
        },

        {
            name: 'Name',
            width: '350px',
            selector: row => row.name,
            cell: row => <span>{row.name}</span>
        },
        {
            name: 'PAN',
            selector: row => row.pan,
            cell: row => <span>{row.pan ? row.pan.toUpperCase() : '-'}</span>
        },
        {
            name: 'Mobile',
            selector: row => row.mobile,
            cell: row => <span>{row.mobile}</span>
        }

    ];

    const RM_COLUMN = [

        {
            name: <div className={`position-relative w-fit-content `}>


                <p className="mb-0">Name</p>
            </div>,
            selector: row => row['name'],
            sortable: true,
            left: true,
            width: '300px',
            cell: row =>
                <div className="d-flex align-items-center gap-12px e-fund-name ps-2" >

                    <p className="color-primary-color e-poppins-regular e-font-16 line-height-24px mb-0 bg-white mt-0">{row['name']}</p>
                </div>
        },
        {
            name: 'Code',
            selector: row => row['code'],
            sortable: false,
            left: true,
            width: '300px',
            cell: row => <span className="color-outer-space"> {row['code']}</span>,
        },
        {
            name: '',
            sortable: false,
            center: true,
            width: "300px",
            cell: (row, key) =>
                <div className="d-flex">
                    <p className='color-primary-color line-height-16px e-poppins-regular e-font-16 e-tool-tip-container position-relative h-fit-content  my-0 cursor-pointer'
                        data-tooltip-content="Edit selected"
                        placement="bottom"
                        onClick={() => _handleEdit(row)}>
                        Edit
                        <Icon icon="Pen-square"
                            size={24}
                            className="ms-1" />
                    </p>
                    <p className={`${showDeletedRed === key ? 'color-red' : 'color-primary-color'} line-height-16px e-poppins-regular e-font-16  my-0 ps-3 e-tool-tip-container position-relative h-fit-content`}
                        data-tooltip-content="Delete selected"
                        placement="bottom"
                        onMouseEnter={() => {
                            setShowDeletedRed(key);
                        }}
                        onMouseLeave={() => {
                            setShowDeletedRed(-1);
                        }}
                        onClick={() => _handleDeleteClick(row)}>
                        Remove


                        <Icon icon={showDeletedRed === key ? "delete-red" : "delete"}
                            size={24}
                        />

                    </p>
                </div>
        },

    ];

    const AP_COLUMN = [

        {
            name: <div className={`position-relative w-fit-content `}>


                <p className="mb-0">Name</p>
            </div>,
            selector: row => row['name'],
            sortable: true,
            left: true,
            width: '260px',
            cell: row =>
                <div className="d-flex align-items-center gap-12px e-fund-name ps-2" >

                    <p className="color-primary-color e-poppins-regular e-font-16 line-height-24px mb-0 bg-white mt-0">{row['name']}</p>
                </div>
        },
        {
            name: 'Code',
            selector: row => row['code'],
            sortable: false,
            left: true,
            width: '260px',
            cell: row => <span className="color-outer-space"> {row['code']}</span>,
        },
        {
            name: '',
            sortable: false,
            center: true,
            width: "300px",
            cell: (row, key) =>
                <div className="d-flex">
                    <p className='color-primary-color line-height-16px e-poppins-regular e-font-16 e-tool-tip-container position-relative h-fit-content  my-0 cursor-pointer'
                        data-tooltip-content="Edit selected"
                        placement="bottom"
                        onClick={() => _handleEdit(row)}>
                        Edit
                        <Icon icon="Pen-square"
                            size={24}
                            className="ms-1" />
                    </p>
                    <p className='color-primary-color line-height-16px e-poppins-regular e-font-16 my-0 ps-3'
                        data-tooltip-content="Transfer customers to another AP"
                        placement="bottom"
                        style={{ opacity: row.has_customer === true ? 1 : 0.3, pointerEvents: row.has_customer === true ? "auto" : "none" }}
                        onClick={() => _handleTransferClick(row)}>
                        Transfer
                    </p>
                    <p className={`${showDeletedRed === key ? 'color-red' : 'color-primary-color'} line-height-16px e-poppins-regular e-font-16  my-0 ps-3 e-tool-tip-container position-relative h-fit-content`}
                        data-tooltip-content="Delete selected"
                        placement="bottom"
                        onMouseEnter={() => {
                            setShowDeletedRed(key);
                        }}
                        onMouseLeave={() => {
                            setShowDeletedRed(-1);
                        }}
                        onClick={() => _handleDeleteClick(row)}>
                        Remove


                        <Icon icon={showDeletedRed === key ? "delete-red" : "delete"}
                            size={24}
                        />

                    </p>
                </div>
        },

    ];


    // useEffect(() => {
    //     if (tabIndex === 1) {
    //         _getZone();
    //     } else if (tabIndex === 2) {
    //         _getRegionData();
    //     } else if (tabIndex === 3) {
    //         _getBranchData();
    //     } else {
    //         _getRmData();
    //     }
    //     setApiLoader(true);
    // }, [tabIndex]);


    useEffect(() => {

        if (state && state.tab_index) {
            setTabIndex(state.tab_index);
        }

    }, [state]);

    useEffect(() => {

        if (tabIndex === 1) {
            _getZone();
        }
        else if (tabIndex === 2) {
            _getRegionData();
        }
        else if (tabIndex === 3) {
            _getBranchData();
        }
        else if (tabIndex === 4) {
            _getRmData();
        } else if (tabIndex === 5) {
            _getApData();
        } else {
            _getAdminTypes();
        }

    }, [tabIndex]);

    useEffect(() => {
        if (openCreateModal === true) {
            const modal = new Modal(document.getElementById("create-rm"));
            modal.show();
        }
    }, [openCreateModal]);

    useEffect(() => {
        if (openTransferModal === true) {
            const modal = new Modal(document.getElementById("transfer-ap"));
            modal.show();
        }
    }, [openTransferModal]);

    useEffect(() => {
        if (openDeleteModal === true) {
            const modal = new Modal(document.getElementById("remove-rm"));
            modal.show();
        }
    }, [openDeleteModal]);

    //Handle tab change
    function _handleTab(index) {

        if (index === 6 && !isOpsAdmin) {
            return; // block non ops admins
        }

        navigate(".", {
            state: { tab_index: index }
        });

        setTabIndex(index);
        setOpenCreaetModal(false);
        setOpenDeleteModal(false);
        setOpenTransferModal(false);
        setSelectedZone({});
        setSelectedRegion({});
        setSelectedBranch({});
        setSelectedRM({});
    }

    function _handleModalClose() {
        setOpenCreaetModal(false);
        setSelectedData(null);
    }

    function _handleEdit(row) {
        if (tabIndex === 1) {
            setModalTitle('Update region');
        } else if (tabIndex === 2) {
            setModalTitle("Update zone");
        } else if (tabIndex === 3) {
            setModalTitle("Update branch");
        } else if (tabIndex === 4) {
            setModalTitle("Update RM");
        } else {
            setModalTitle("Update AP");
        }
        setSelectedData(row);
        setOpenCreaetModal(true);
    }

    function _handleDeleteClick(row) {
        setSelectedId(row.id);
        if (row.has_customer === true || row.has_admin === true) {
            setRemapAvailable(true);
        }
        setOpenDeleteModal(true);
    }

    function _handleTransferClick(row) {
        setSelectedTransferRow(row);
        setOpenTransferModal(true);
    }

    function _handleTransferModalClose() {
        setOpenTransferModal(false);
        setSelectedTransferRow(null);
    }

    function _handleTransferConfirm() {
        setOpenTransferModal(false);
        setSelectedTransferRow(null);
        _getApData(selectedRM?.value);
    }

    function _openCreateModal() {
        let modal_title = ""
        if (tabIndex === 1) {
            modal_title = "Create new region";
        } else if (tabIndex === 2) {
            modal_title = "Create new zone";
        } else if (tabIndex === 3) {
            modal_title = "Create new branch";
        }
        else if (tabIndex === 4) {
            modal_title = "Create new RM";
        }
        else {
            modal_title = "Create new AP";
        }
        setModalTitle(modal_title);
        setOpenCreaetModal(true);
    }

    function _selectZone(value) {
        setSelectedZone(value);
        setSelectedRegion({});
        setSelectedBranch({});
        _getRegionData(value.value);
    };

    function _selectFromAdmin(value) {

        setFromAdmin(value);
        setSelectedCustomers([]);
        setCurrentPage(1);

        if (value && adminType) {
            _getAdminCustomers(value.value, adminType.value, 1, pageSize);
        }

    }

    function _handleRowsChange(rows) {

        setPageSize(rows);
        setCurrentPage(1);

        _getAdminCustomers(
            fromAdmin.value,
            adminType.value,
            1,
            rows,
            searchQuery
        );
    }

    function _handlePageChange(page) {

        setCurrentPage(page);

        _getAdminCustomers(
            fromAdmin.value,
            adminType.value,
            page,
            pageSize,
            searchQuery
        );

    }


    function _toggleCustomer(id) {

        let updatedCustomers;

        if (selectedCustomers.includes(id)) {
            updatedCustomers = selectedCustomers.filter(item => item !== id);
        } else {
            updatedCustomers = [...selectedCustomers, id];
        }

        setSelectedCustomers(updatedCustomers);

        if (updatedCustomers.length === customerList.length) {
            setSelectAllCustomers(true);
        } else {
            setSelectAllCustomers(false);
        }

    }

    function _toggleSelectAll() {

        if (selectAllCustomers) {
            setSelectedCustomers([]);
            setSelectAllCustomers(false);
        } else {
            const allCustomerIds = customerList.map(item => item.customer_id);
            setSelectedCustomers(allCustomerIds);
            setSelectAllCustomers(true);
        }

    }

    function _selectRegion(value) {
        setSelectedRegion(value);
        setSelectedBranch({});
        setSelectedRM({});
        _getBranchData(value.value);
    }

    const _handleSearchQuery = (value) => {
        const formattedValue = value.toUpperCase();
        setCurrentPage(1);
        setSearchQuery(formattedValue);

        if (formattedValue === "") {
            _getAdminCustomers(fromAdmin.value, adminType.value, 1, pageSize, "");
        }

    };

    function _selectBranch(value) {
        setSelectedBranch(value);
        setSelectedRM({});
        _getRmData(value.value);
    }

    function _selectRM(value) {
        setSelectedRM(value);
        _getApData(value.value);
    }

    function _reloadData(type) {
        setOpenDeleteModal(false);
        setSelectedId(null);
        _updateList(type);
    };

    function _selectAdminType(value) {

        setAdminType(value);
        setFromAdmin({});
        setToAdmin({});
        setCustomerList([]);
        setSelectedCustomers([]);

        if (value.value === 4) {
            _getZone();
        }
        else if (value.value === 5) {
            _getRegionData();
        }
        else if (value.value === 6) {
            _getBranchData();
        }
        else if (value.value === 7) {
            _getRmData();
        }
        else {
            _getAssociateList();
        }

    }

    function _updateList(type) {
        if (type === 1) {
            _getZone();
        } else if (type === 2) {
            _getRegionData(selectedZone?.value);
        } else if (type === 3) {
            _getBranchData(selectedRegion?.value);
        } else if (type === 4) {
            _getRmData(selectedBranch?.value);
        } else {
            _getApData(selectedRM?.value);
        }
    }

    // API - get zone data
    function _getZone() {
        if (tabIndex === 1) {
            setApiLoader(true);
        }
        let url = "client_mapping/zone/list";
        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                if (tabIndex === 1) {
                    setTableData(response.data);
                }
                const modified_data = response.data.map((item) => {
                    return {
                        value: item.id,
                        label: `${item.name} (${item.code})`
                    }
                });
                setZoneList(modified_data);
            } else {
                setTableData([]);
            }
            setApiLoader(false);
        })
    }

    // API - get RM data
    function _getRegionData(zone = null) {
        if (tabIndex === 2) {
            setApiLoader(true);
        }
        let url = 'client_mapping/region/list';
        let payload = JSON.stringify({
            id: zone
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                if (tabIndex === 2) {
                    setTableData(response.data);
                }
                const modified_data = response.data.map((item) => {
                    return {
                        value: item.id,
                        label: `${item.name} (${item.code})`
                    }
                });
                setRegionList(modified_data);
            } else {
                setRegionList([]);
                if (tabIndex === 2) {
                    setTableData([]);
                }
            }
            setApiLoader(false);
        })
    }

    // API - get Branch data
    function _getBranchData(rm_id = null) {
        if (tabIndex === 3) {
            setApiLoader(true);
        }
        let url = 'client_mapping/branch/list';
        let payload = JSON.stringify({
            id: rm_id
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                console.log('tabIndex', tabIndex);
                if (tabIndex === 3) {
                    setTableData(response.data);
                }
                const modified_data = response.data.map((item) => {
                    return {
                        value: item.id,
                        label: `${item.name} (${item.code})`
                    }
                });
                setBranchList(modified_data);
            } else {
                setBranchList([]);
                if (tabIndex === 3) {
                    setTableData([]);
                }
            }
            setApiLoader(false);
        })
    }

    function _getAssociateList() {

        let url = "client_mapping/ap/list";

        let payload = JSON.stringify({
            id: null
        });

        APIService(true, url, payload).then((response) => {

            if (response.status_code === 200) {

                const modified_data = response.data.map((ap) => ({
                    ...ap,
                    value: ap.id,
                    label: ap.name
                }));

                setAssociateList(modified_data);

            } else {
                setAssociateList([]);
            }

        });

    }

    // API - get RM data
    function _getRmData(branch_id = null) {
        if (tabIndex === 4) {
            setApiLoader(true);
        }
        let url = 'client_mapping/rm/list';
        let payload = JSON.stringify({
            id: branch_id
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                if (tabIndex === 4) {
                    setTableData(response.data);
                }
                const modified_data = response.data.map((item) => ({
                    value: item.id,
                    label: `${item.name} (${item.code})`
                }));

                setRmList(modified_data);
            } else {
                setRmList([]);
                if (tabIndex === 4) {
                    setTableData([]);
                }
            }
            setApiLoader(false);
        })
    };

    // API - get AP data
    function _getApData(rm_id = null) {
        if (tabIndex === 5) {
            setApiLoader(true);
        }
        let url = 'client_mapping/ap/list';
        let payload = JSON.stringify({
            id: rm_id
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                if (tabIndex === 5) {
                    setTableData(response.data);
                }
            } else {
                if (tabIndex === 5) {
                    setTableData([]);
                }
            }
            setApiLoader(false);
        })
    };


    function _getAdminCustomers(admin_id, admin_type_id, page = currentPage, limit = 10, query = searchQuery) {

        setApiLoader(true);

        let payload = JSON.stringify({
            admin_id: admin_id,
            admin_type_id: admin_type_id,
            page_num: page,
            page_size: limit,
            query: query
        });

        APIService(true, "user/admin-user-list", payload).then((res) => {

            if (res.status_code === 200) {

                // Correct mapping
                setCustomerList(Array.isArray(res.data.user_list) ? res.data.user_list : []);
                let total_pages = Math.ceil(res.data.number_of_records / res.data.page_size);
                setTotalPages(total_pages);
                setTotalLength(res.data.number_of_records || 0);

                // setCurrentPage(res.data.current_page || 1);
                setPageSize(res.data.page_size);
                setPaginationData({
                    rowsPerPageText: `${res.data.current_page} of ${Math.ceil(res.data.number_of_records / res.data.page_size)} | Total records: ${res.data.number_of_records}`
                });

            } else {
                setCustomerList([]);
            }

            setApiLoader(false);

        });
    }

    function _transferAdmin() {

        if (fromAdmin.value === toAdmin.value) {
            toast.dismiss();
            toast.error("From Admin and To Admin cannot be same");
            return;
        }

        const customersToTransfer =
            selectedCustomers.length === 0
                ? customerList.map(item => item.customer_id)
                : selectedCustomers;

        let payload = JSON.stringify({
            from_admin: fromAdmin.value,
            to_admin: toAdmin.value,
            admin_type: adminType.value,
            is_delete: deleteOldAdmin,
            customer_ids: customersToTransfer
        });

        APIService(true, "user/change-admin", payload).then((res) => {

            if (res.status_code === 200) {

                const transferCount = customersToTransfer.length;
                const fromCode = fromAdmin.label || fromAdmin.value;
                const toCode = toAdmin.label || toAdmin.value;

                let message = `${transferCount} customer${transferCount > 1 ? "s" : ""} transferred from ${fromCode} to ${toCode}`;

                if (deleteOldAdmin) {
                    message += " and old admin deleted";
                }

                toast.success(message);

                // reset states
                setCustomerList([]);
                setSelectedCustomers([]);
                setSelectAllCustomers(false);

                setFromAdmin({});
                setToAdmin({});
                setAdminType({});

                setDeleteOldAdmin(false);
                setSearchQuery("");
            }

        });

    }

    // API - get admin types
    function _getAdminTypes() {

        let url = 'auth/admin-types-filter';

        APIService(false, url).then((response) => {

            if (response.status_code === 200) {

                let admin_types = response.data
                    .filter(item => item.id >= 4)
                    .map((item) => {
                        return {
                            value: item.id,
                            label: item.name
                        }
                    });

                setAdminOptions(admin_types);
            }

        });

    };

    const isDeleteAllowed = customerList.length >= 0;

    return (
        <>
            <NavigationHeader
                type={1}
                data={PAGE_NAVIGATION}
                title="Manage Hierarchy" />
            <div className=" e-manage-sip ps-4 pe-lg-5 pe-md-2 pe-2 padding-32px-top">
                <p className="color-black e-poppins-medium e-font-20-sm-18 line-height-32px my-sm-4 my-3">Manage Hierarchy</p>
                <div className="row">
                    <div className="col-9 scrollbar-container overflow-auto white-space-nowrap">
                        <CustomTab type={1}
                            index={tabIndex}
                            data={TAB_DATA}
                            onSelectTab={_handleTab} />
                    </div>
                    <div className="col-3 text-end">
                        {tabIndex !== 6 && (
                            <GradientButton
                                label={`Create ${tabIndex === 1 ? "Region" : tabIndex === 2 ? "Zone" : tabIndex === 3 ? "Branch" : tabIndex === 4 ? "RM" : "AP"}`}
                                onPress={_openCreateModal}
                            />
                        )}
                    </div>
                </div>

                {tabIndex !== 6 &&
                    <div className="row mt-4">
                        <div className="col-12">
                            <div className="d-flex w-100 justify-content-end">
                                {
                                    tabIndex > 1 &&
                                    <CustomSearchSelectBox options={zoneList}
                                        value={Object.keys(selectedZone).length === 0 ? "" : selectedZone}
                                        label="Select region"
                                        className="w-25"
                                        id="admin-zone"
                                        hide_error_text={false}
                                        placeholder=""
                                        onSelectChange={_selectZone} />
                                }

                                {
                                    tabIndex > 2 &&
                                    <CustomSearchSelectBox options={regionList}
                                        value={Object.keys(selectedRegion).length === 0 ? "" : selectedRegion}
                                        label="Select zone"
                                        className="w-25 ms-3"
                                        id="admin-zone"
                                        hide_error_text={false}
                                        placeholder=""
                                        onSelectChange={_selectRegion} />
                                }

                                {
                                    tabIndex > 3 &&
                                    <CustomSearchSelectBox options={branchList}
                                        value={Object.keys(selectedBranch).length === 0 ? "" : selectedBranch}
                                        label="Select branch"
                                        className="w-25 ms-3"
                                        id="admin-zone"
                                        hide_error_text={false}
                                        placeholder=""
                                        onSelectChange={_selectBranch} />
                                }

                                {
                                    tabIndex > 4 &&
                                    <CustomSearchSelectBox options={rmList}
                                        value={Object.keys(selectedRM).length === 0 ? "" : selectedRM}
                                        label="Select RM"
                                        className="w-25 ms-3"
                                        id="admin-zone"
                                        hide_error_text={false}
                                        placeholder=""
                                        onSelectChange={_selectRM} />
                                }

                            </div>
                        </div>
                    </div>
                }
                <div className="row">

                    {
                        tabIndex !== 6 && (
                            apiLoader === true ?
                                <div className="col-12 h-80vh">
                                    <CustomLoader />
                                </div>
                                :
                                tableData.length !== 0 ?
                                    <div className="min-height-80vh">
                                        <div className="col-12 position-relative" id="e-table-body">
                                            <DataTableContainer columns={tabIndex === 1 ? ZONE_COLUMNS : tabIndex === 2 ? REGION_COLUMN : tabIndex === 3 ? BRNACH_COLUMN : tabIndex === 4 ? RM_COLUMN : AP_COLUMN}
                                                data={tableData}
                                                selectableRows={false}
                                                pagination={false}
                                                customStyles={TABLE_STYLE} />
                                        </div>
                                    </div>
                                    :
                                    <div className="mb-5">
                                        <EmptyScreen title="Empty user data!" />
                                    </div>
                        )
                    }


                    {
                        tabIndex === 6 && isOpsAdmin && (
                            <div className="row mt-4">

                                <div className="col-12">

                                    <h3 className="text-center mb-4">Admin Transfer</h3>

                                    {/* DROPDOWNS ROW */}

                                    <div className="row">

                                        <div className="col-md-4">
                                            <CustomSearchSelectBox
                                                options={adminOptions}
                                                value={adminType}
                                                label="Admin Type"
                                                onSelectChange={_selectAdminType}
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <CustomSearchSelectBox
                                                options={
                                                    adminType.value === 4 ? zoneList :
                                                        adminType.value === 5 ? regionList :
                                                            adminType.value === 6 ? branchList :
                                                                adminType.value === 7 ? rmList :
                                                                    adminType.value === 8 ? associateList :
                                                                        []
                                                }
                                                value={fromAdmin}
                                                label="From Admin"
                                                onSelectChange={_selectFromAdmin}
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <CustomSearchSelectBox
                                                options={
                                                    adminType.value === 4 ? zoneList :
                                                        adminType.value === 5 ? regionList :
                                                            adminType.value === 6 ? branchList :
                                                                adminType.value === 7 ? rmList :
                                                                    adminType.value === 8 ? associateList :
                                                                        []
                                                }
                                                value={toAdmin}
                                                label="To Admin"
                                                onSelectChange={(value) => setToAdmin(value)}
                                            />
                                        </div>

                                    </div>


                                    {/* DELETE ADMIN - HIGHLIGHTED */}

                                    <div className="mt-3 d-flex align-items-center justify-content-between">

                                        <div className="p-3 border-radius-8px border-all border-bright-gray bg-pale-yellow d-flex align-items-center">

                                            <input
                                                type="checkbox"
                                                checked={deleteOldAdmin}
                                                disabled={!isDeleteAllowed}
                                                onChange={() => setDeleteOldAdmin(!deleteOldAdmin)}
                                                className="cursor-pointer"
                                            />

                                            <span className="ms-2 e-poppins-medium color-black">
                                                Delete Old Admin
                                            </span>

                                        </div>

                                        <div style={{ width: "600px" }}>
                                            <SearchInput
                                                placeholder="Search by client code, name, PAN, email, mobile or customer ID"
                                                value={searchQuery}
                                                className="padding-12px-tb"
                                                valueChange={_handleSearchQuery}
                                                handleSearch={() =>
                                                    _getAdminCustomers(fromAdmin.value, adminType.value, 1, pageSize, searchQuery)
                                                }
                                            />
                                        </div>

                                    </div>

                                    {/* CUSTOMER LIST */}

                                    <div className="row mt-4">

                                        {
                                            apiLoader === true ?

                                                <div className="col-12 h-80vh">
                                                    <CustomLoader />
                                                </div>

                                                :

                                                customerList.length !== 0 ?

                                                    <div className="min-height-80vh">

                                                        <div className="col-12 position-relative">

                                                            <DataTableContainer
                                                                columns={CUSTOMER_COLUMNS}
                                                                data={customerList}
                                                                pagination={totalLength > 10}
                                                                paginationServer={true}
                                                                paginationTotalRows={totalLength}
                                                                paginationDefaultPage={currentPage}
                                                                selectableRows={false}
                                                                customStyles={TABLE_STYLE}
                                                                paginationComponentOptions={paginationData}
                                                                paginationPerPage={pageSize}
                                                                onChangeRowsPerPage={_handleRowsChange}
                                                                onChangePage={_handlePageChange}
                                                            />
                                                            <div className="d-flex justify-content-end align-items-center position-absolute bottom-16px right-24 w-max-content mt-3">

                                                                <Icon
                                                                    icon="pagination-previous"
                                                                    width="24px"
                                                                    height="24px"
                                                                    className={currentPage === 1 ? "pointer-events-none opacity-4 mx-3" : "mx-3 cursor-pointer"}
                                                                    onClick={() => {
                                                                        if (currentPage > 1) {
                                                                            _handlePageChange(currentPage - 1);
                                                                        }
                                                                    }}
                                                                />

                                                                <Icon
                                                                    icon="pagination-next"
                                                                    width="24px"
                                                                    height="24px"
                                                                    className={currentPage === totalPages ? "ms-1 pointer-events-none opacity-4" : "ms-1 cursor-pointer"}
                                                                    onClick={() => {
                                                                        if (currentPage < totalPages) {
                                                                            _handlePageChange(currentPage + 1);
                                                                        }
                                                                    }}
                                                                />

                                                            </div>

                                                        </div>

                                                    </div>

                                                    :

                                                    <div className="mb-5">
                                                        <EmptyScreen title="No customers found!" />
                                                    </div>

                                        }

                                    </div>


                                    {/* BUTTON */}

                                    <div className="mt-4 text-center">

                                        <GradientButton
                                            label="Transfer Admin"
                                            onPress={_transferAdmin}
                                            disabled={!fromAdmin?.value || !toAdmin?.value}
                                        />

                                    </div>

                                </div>

                            </div>
                        )
                    }
                </div>
            </div>
            {
                openCreateModal === true &&
                <CreateRMModal type={tabIndex}
                    data={selectedData}
                    zoneList={zoneList}
                    heading={modalTitle}
                    updateList={_updateList}
                    close={_handleModalClose} />
            }
            {
                openDeleteModal === true &&
                <RemoveRMModal type={tabIndex}
                    id={selectedId}
                    zoneList={zoneList}
                    remapAvailable={remapAvailable}
                    close={() => { setOpenDeleteModal(false); setSelectedId(null); setRemapAvailable(false) }}
                    confirmDelete={_reloadData} />
            }
            {
                openTransferModal === true &&
                <TransferAPModal id={selectedTransferRow?.id}
                    name={selectedTransferRow?.name}
                    close={_handleTransferModalClose}
                    confirmTransfer={_handleTransferConfirm} />
            }
        </>
    )
}
